import React,{ useState , useEffect} from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath,faCar,faClock ,faEdit,faTrash} from '@fortawesome/free-solid-svg-icons'; 
import "./adminprop.css";
import AdminLayout from "./AdminLayout";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Grid,
  Card,
  CardContent,
  IconButton,
  LinearProgress,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Home as HomeIcon,
  Apartment as ApartmentIcon,
  Category as CategoryIcon,
  Person as PersonIcon,
  Map as MapIcon,
  Assessment as AssessmentIcon,
  Apps as AppsIcon,
} from "@mui/icons-material";

const Bureau_commerce = () => {
  const handleLogout = () => {
    console.log("Déconnexion");
  };

  const handleNotifications = () => {
    console.log("Afficher les notifications");
  };

  const [setFilteredProducts] = useState([]);

  const navigate = useNavigate(); // Pour la navigation avec React Router v5
  const [openSublist, setOpenSublist] = useState(null);

  const handleSublistToggle = (index) => {
    setOpenSublist((prev) => (prev === index ? null : index)); // Toggle ouvrir/fermer sous-liste
  };

  const handleNavigation = (path) => {
    navigate(path); // Redirection vers une autre page
  };

  const fullName = localStorage.getItem("fullName") || "Utilisateur non connecté";
  const role = localStorage.getItem("role") || "Non défini";

  // Données du graphique
  const [products, setProducts] = useState([]);
  // Modification



  // Effet pour récupérer les produits depuis le backend
  useEffect(() => {
    // Fonction pour récupérer les produits
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');  // URL de votre backend
        setProducts(response.data);  // Met à jour l'état avec les produits récupérés
      } catch (error) {
        console.error('Erreur lors de la récupération des produits:', error);
      }
    };

    fetchProducts();  // Appel de la fonction pour récupérer les produits
  }, []);  // Le tableau vide [] indique que l'effet s'exécute une seule fois lors du montage du composant

  const handleEdit = (id) => {
    console.log(`Modifier la propriété avec ID: ${id}`);
    navigate(`/edit-property/${id}`);
};

const handleDelete = async (id) => {
  if (window.confirm("Voulez-vous vraiment supprimer cette propriété ?")) {
    try {
      // Envoi de la requête DELETE à l'API
      const response = await axios.delete(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/${id}`);
      if (response.status === 200) {
        // Mise à jour de l'état des produits après suppression
        setProducts((prevProducts) => prevProducts.filter((product) => product._id !== id));
        alert('Propriété supprimée avec succès');
      }
    } catch (error) {
      console.error('Erreur lors de la suppression de la propriété:', error);
      alert('Échec de la suppression de la propriété');
    }
  }
};


  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("Résidentiel");
  const [transactionType, setTransactionType] = useState("À vendre");
  const [price, setPrice] = useState("");
  const [lifestyleFilters, setLifestyleFilters] = useState(1);


  // Filtrer les produits pour afficher uniquement ceux à vendre
 const filteredProducts = products.filter(
  (product) => product.productType === "bureau_commerce"
);


  return (
    <AdminLayout>
    <Box sx={{ display: "flex" }}>
      {/* Sidebar fixe */}
    

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, bgcolor: "#f5f5f5", padding: 3 }}>
        {/* Top Bar */}
     
        <div>
        <div className="row">
  {filteredProducts.map((product) => (
    <div key={product._id} className="col-lg-12 d-flex align-items-center mb-3" style={{ gap: "10px" }}>
      {/* Image */}
      <div style={{ width: "30%" }}>
        <img
          src={product.images[0] || "/path/to/default-image.jpg"}
          alt={product.title}
          className="property-image"
          style={{
            width: "80%",
            height: "auto",
            borderRadius: "10px",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Details */}
      <div style={{ width: "70%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <div>
          <h6>{product.price?.toLocaleString()} FCFA</h6>
          <h6>{product.title}</h6>
          <p>{product.address}, {product.city}</p>
          <div className="property-features">
            <span style={{ marginRight: "10px" }}>
              <FontAwesomeIcon icon={faBed} /> {product.features?.bedrooms || 0}
            </span>
            <span style={{ marginRight: "10px" }}>
              <FontAwesomeIcon icon={faBath} /> {product.features?.bathrooms || 0}
            </span>

            {/* Icons Edit and Delete */}
            <div style={{ display: "flex", alignItems: "center", marginTop: "10px", gap: "20px" }}>
              <FontAwesomeIcon
                icon={faEdit}
                style={{ color: "orange", cursor: "pointer" }}
                onClick={() => handleEdit(product._id)}
              />
              <FontAwesomeIcon
                icon={faTrash}
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => handleDelete(product._id)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

        <br/>
        </div>
        
      </Box>
    </Box>
    </AdminLayout>
  );
};

export default Bureau_commerce;
